import { Card, Stack, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import CustomTabPanel from './TabPanel';
import LoadingContent from 'components/LoadingContent';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
import activitiesAndHonorsServices from 'services/activitiesAndHonorsServices';
import { buildClassName, buildPageStatusClassName } from './RPersonalInformation';
import { formatBoolean, formatBooleanToYesNo } from 'components/helper/helper';
import { usePageStatus } from 'hooks/usePageStatus';
import websocketService from 'services/websocketService';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';


const RAdditionalInfo = ({ setCurrentModuleId, isCounselor }: { setCurrentModuleId: (id: string) => void, isCounselor?: boolean }) => {
  const [myAdditionalInfo, setMyAdditionalInfo] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const params: { id?: string | number } = useParams();
  const { pageStatus } = usePageStatus({ studentId: params.id || '' });
  const [reviewedAndComplete1, setReviewedAndComplete1] = React.useState(false);
  const [reviewedAndComplete2, setReviewedAndComplete2] = React.useState(false);
  const [reviewedAndComplete3, setReviewedAndComplete3] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const reviewGeneral = () => {
    const newValue = !reviewedAndComplete1;
    setReviewedAndComplete1(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ADDITIONAL_INFO_1, newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ADDITIONAL_INFO, newValue);
  }
  
  const reviewCommonApp = () => {
    const newValue = !reviewedAndComplete2;
    setReviewedAndComplete2(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ADDITIONAL_INFO_2, newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ADDITIONAL_INFO, newValue);
  }
  
  const reviewUCApp = () => {
    const newValue = !reviewedAndComplete3;
    setReviewedAndComplete3(newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ADDITIONAL_INFO_3, newValue);
    websocketService.finishReviewAndCompleteCounselor(PAGE_NAME.ADDITIONAL_INFO, newValue);
  }

  // const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  // const [show, setShow] = React.useState(false); // show model checkfield
  // const handleCloseModalCheck = () => {
  //   setShow(false);
  // };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getData = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const [page1, page2, page3]: [any, any, any] = await Promise.all([
        pageStatusService.getPageStatusByPageName(params.id, PAGE_NAME.ADDITIONAL_INFO_1),
        pageStatusService.getPageStatusByPageName(params.id, PAGE_NAME.ADDITIONAL_INFO_2),
        pageStatusService.getPageStatusByPageName(params.id, PAGE_NAME.ADDITIONAL_INFO_3),
      ]);
      setReviewedAndComplete1(page1?.counselor_verified);
      setReviewedAndComplete2(page2?.counselor_verified);
      setReviewedAndComplete3(page3?.counselor_verified);

      let res: any = await activitiesAndHonorsServices.getAdditionalInfo(params.id);
      if (res==='') res = null; //force is null to check data 
      setMyAdditionalInfo(res);
      setLoading(false);
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  const [value, setValue] = React.useState(1);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`7.${newValue}`);
  };

  const wordCount1 = (myAdditionalInfo?.additional_comment_1 || '0')
    .split(/\s+/)
    .filter(Boolean).length;

  const wordCount2 = (myAdditionalInfo?.additional_comment_2 || '0')
    .split(/\s+/)
    .filter(Boolean).length;

  const wordCount3 = (myAdditionalInfo?.additional_comment_3 || '0')
  .split(/\s+/)
  .filter(Boolean).length;

  return (
    <div>
      <Tabs
        className='mt-2'
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          position: 'sticky',
          top: isCounselor ? '72px' : '0',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab value={1} label="General" className={
          buildPageStatusClassName(pageStatus, PAGE_NAME.ADDITIONAL_INFO_1)
        } />
        <Tab value={2} label="Common App" className={
          buildPageStatusClassName(pageStatus, PAGE_NAME.ADDITIONAL_INFO_2)
        } />
        <Tab value={3} label="UC App" className={
          buildPageStatusClassName(pageStatus, PAGE_NAME.ADDITIONAL_INFO_3)
        } />
      </Tabs>
      <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <div className="gm-summary-container">
              <div className="d-flex justify-content-between mb-4">
                <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
                  General
                </Typography>
              </div>
              <div className="gm-summary-section">
                <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
                  Sometimes applicants encounter challenges that impact their education and
                  application. Colleges care about effects on your health and well-being, safety,
                  family circumstances, future plans, and education — including access to reliable
                  technology and quiet study spaces. Use this space if you want to share how
                  challenges or other circumstances might have impacted your application and
                  achievements.
                </div>
                {myAdditionalInfo && (
                  <div>
                    <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                      <div className="gm-summary-field-label">
                        Do you wish to share anything on this topic?*
                      </div>
                      <div className="gm-summary-field-value">
                        {formatBooleanToYesNo(myAdditionalInfo?.wish_to_share_option)}
                      </div>
                    </div>
                    {formatBoolean(myAdditionalInfo?.wish_to_share_option) && (
                      <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                        <div className="gm-summary-field-label">
                          Please use this space to describe how these events have impacted you.*
                        </div>
                        <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap' }}>
                          {myAdditionalInfo?.additional_comment_3 || '-'}
                        </div>
                        <div className="gm-summary-field-count" style={{ textAlign: 'right' }}>
                          Word count: {wordCount3}/250
                        </div>
                      </div>
                    )}
                    <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                      <div className="gm-summary-field-label">
                        Do you wish to provide details of circumstances or qualifications not
                        reflected in the application?*
                      </div>
                      <div className="gm-summary-field-value">
                        {formatBooleanToYesNo(myAdditionalInfo?.wish_to_provide_detail_of_circumstances_option)}
                      </div>
                    </div>
                    {formatBoolean(myAdditionalInfo?.wish_to_provide_detail_of_circumstances_option) && (
                      <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                        <div className="gm-summary-field-label">Additional Information</div>
                        <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap' }}>
                          {myAdditionalInfo?.additional_comment_1 || '-'}
                        </div>
                        <div className="gm-summary-field-count" style={{ textAlign: 'right' }}>
                          Word count: {wordCount1}/300
                        </div>
                      </div>
                    )}
                    <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                      <div className="gm-summary-field-label">Additional Comments</div>
                      <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap' }}>
                        {myAdditionalInfo?.additional_comment_2 || '-'}
                      </div>
                      <div className="gm-summary-field-count" style={{ textAlign: 'right' }}>
                        Word count: {wordCount2}/550
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Stack>
          {getUserRole() === USER_ROLE.counselor && (
              <div className="gm-summary-checkbox-container">
                <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                  <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete1} onClick={reviewGeneral} />
                  <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
                </div>
              </div>
            )}
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <div className="gm-summary-container">
            <div className="d-flex justify-content-between mb-4">
              <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
                Common App
              </Typography>
            </div>
            {loading ? (
              <LoadingContent />
            ) : (
              <div className="gm-summary-section">
                <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                  <div className="gm-summary-field-label">
                    Please use this space to describe how these events have impacted you.*
                  </div>
                  <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap' }}>
                    {myAdditionalInfo?.additional_comment_1 || '-'}
                  </div>
                  <div className="gm-summary-field-count" style={{ textAlign: 'right' }}>
                    Word count: {wordCount1}/300
                  </div>
                </div>
              </div>
            )}
          </div>
          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete2} onClick={reviewCommonApp} />
                <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
              </div>
            </div>
          )}
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <div className="gm-summary-container">
            <div className="d-flex justify-content-between mb-4">
              <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
                UC App
              </Typography>
            </div>
            {loading ? (
              <LoadingContent />
            ) : (
              <div className="gm-summary-section">
                <div className="gm-summary-field-item" style={{ marginBottom: '1rem' }}>
                  <div className="gm-summary-field-label">Additional Comments</div>
                  <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap' }}>
                    {myAdditionalInfo?.additional_comment_2 || '-'}
                  </div>
                  <div className="gm-summary-field-count" style={{ textAlign: 'right' }}>
                    Word count: {wordCount2}/550
                  </div>
                </div>
              </div>
            )}
          </div>
          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input type="checkbox" style={{ width: '16px', height: '16px', border: '2px solid #6c757d', borderRadius: '2px' }} checked={reviewedAndComplete3} onClick={reviewUCApp} />
                <span style={{ fontSize: isMobile ? '14px' : '12px', color: '#6c757d', fontWeight: '500' }}>Reviewed & Complete!</span>
              </div>
            </div>
          )}
        </Card>
      </CustomTabPanel> 
     
    </div>
  );
};

export default RAdditionalInfo;
